import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { TenantSettingsDto, UpdateTenantSettingsRequest } from '@ctms/contracts';

import { tenantsApi } from '../tenants.api.js';
import { tenantQueryKeys } from '../tenants.query-keys.js';

/**
 * Working window of the signed-in site (D4a — feature core-tenant/site-working-hours).
 * Configuration, not live data — a 5-minute stale window matches the other pickers.
 */
export function useTenantSettingsQuery() {
  return useQuery<TenantSettingsDto>({
    queryKey: tenantQueryKeys.settings(),
    queryFn: () => tenantsApi.getSettings(),
    staleTime: 5 * 60 * 1000,
  });
}

/** Saves the window and pushes the server echo straight into the cache. */
export function useUpdateTenantSettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation<TenantSettingsDto, unknown, UpdateTenantSettingsRequest>({
    mutationFn: (request) => tenantsApi.updateSettings(request),
    onSuccess: (saved) => {
      queryClient.setQueryData(tenantQueryKeys.settings(), saved);
    },
  });
}